<style>
    h1 {
        text-transform: capitalize;
    }
</style>
<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Buat Packing</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/penjualan/print-invoice/'+id_transaksi)" class="btn btn-icon icon-left btn-primary"><i class="fas fa-file"></i> Preview Invoice</a>
            </div>
          </div>
         <div class="section-body">
            <h2 class="section-title">Harga Total </h2>
            <p class="section-lead">Dibayar </p>

            <div class="row">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Pelanggan</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Pelanggan</label>
                                <select :disabled="pelangganDis" id="pelanggan" class="form-control select2">
                                    <option v-for="(option,index) in pelangganList" v-bind:key="index" :value="index" >{{ option.display_name}} </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Alamat Pelanggan</label>
                                <textarea disabled class="form-control" v-model="alamat" @focus="auto_alamat()"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input disabled type="text" v-model="email" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Packing</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Nomor Transaksi</label>
                                <input type="text" v-model="nomor_transaksi" class="form-control" disabled>
                            </div>
                            <!-- <div class="form-group">
                                <label>Nomor Invoice</label>
                                <input type="text" v-model="nomor_invoice" class="form-control">
                            </div> -->
                            <div class="form-group">
                                <label>Nomor Surat Jalan / Pengiriman</label>
                                <input type="text" v-model="nomor_pengiriman" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Tanggal Pengiriman</label>
                                <vc-date-picker v-model="tanggal_pengiriman" :input-props='{class: "form-control",placeholder: "Masukkan tanggal pengiriman"}'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Tambahan</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Pesan</label>
                                <textarea class="form-control" v-model="pesan" ></textarea>
                            </div>
                            <div class="form-group mb-0">
                                <label>Memo</label>
                                <textarea class="form-control" v-model="memo" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Daftar Packing Produk</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <tr>
                                        <th>No.</th>
                                        <th>Kode Produk</th>
                                        <th>Produk</th>
                                        <th>Nomor PO</th>
                                        <th>Qty</th>
                                        <th>Pack ?</th>
                                        <th>Qty Pack</th>
                                        <th>Sisa Qty</th>
                                    </tr>
                                    <tbody v-if="bodyRender">
                                        <tr v-for="(data,index) in produkList" v-bind:key="index">
                                            <td>
                                                {{ index+1 }}
                                            </td>
                                            <td>
                                                {{ data.kode_produk }}
                                            </td>
                                            <td>
                                            {{ data.nama_produk }} 
                                            </td>
                                            <td>
                                                {{ data.nomor_transaksi }}
                                            </td>
                                            <td>
                                                {{ data.qty }} {{ data.nama_satuan }}
                                            </td>
                                            <td>
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" class="custom-control-input" :id="'check_'+index" v-model="data.pack_check">
                                                    <label class="custom-control-label" :for="'check_'+index" >Ya</label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <input :disabled="data.pack_check == 0" :max="data.qty - data.qty_dikirim" min="0" type="number" style="width:100px" class="form-control" v-model="data.qty_pack">
                                                </div>
                                            </td>
                                            <td>
                                                {{ data.qty - data.qty_dikirim }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Packaging Dipakai</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table v-if="bodyRender" class="table table-striped table-md">
                                    <tr>
                                        <th>Produk</th>
                                        <th>Stok Tersedia</th>
                                        <th>Satuan</th>
                                        <th>Kuantitas</th>
                                        <th></th>
                                        <!-- <th>Harga Satuan</th>
                                        <th>Jumlah</th> -->
                                    </tr>
                                    <tr v-for="(data,index) in packageList" v-bind:key="index">
                                        <td>
                                            <div class="form-group">
                                                <v-select :id="'produk_'+index" v-model="packageList[index].val" :reduce="text => text.value" :options="dataPackingList" label="text" @input="insertValue(index)"></v-select>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="packageList[index].qty_total" disabled> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" v-model="packageList[index].nama_satuan" disabled> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="number" :max="packageList[index].qty_total" min="0"  v-on:keyup.enter="addItem()" class="form-control" v-model="data.qty_package">
                                            </div>
                                        </td>
                                        <td> <i @click="deleteDataProduk(index)" style="font-size:18px;cursor:pointer;color:red;" class="fa fa-times"></i>  </td>
                                        
                                        <!-- <td>
                                            <div class="form-group">
                                                <input type="text" @change="countHarga(index)" class="form-control" v-model="data.harga_satuan"> 
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" class="form-control" @change="countSatuan(index)" v-model="data.jumlah_harga"> 
                                            </div>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td style="padding-top:5%;">
                                            <button @click="addItem()" class="btn btn-primary">+ Tambah Data</button>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <th colspan="4" style="text-align:right">Dibayar</th>
                                        <th>
                                            <div class="form-group">
                                                <input type="text" v-model="dibayar" v-imask="mask" class="form-control"> 
                                            </div>
                                        </th>
                                    </tr> -->
                                    <!-- <tr>
                                        <th style="text-align:right" colspan="4">Total Tagihan</th>
                                        <th>Rp. {{ currencyFormat(total_semua) }}</th>
                                    </tr> -->
                                    
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="submitPacking()" class="btn btn-info"> <i class="fas fa-box"></i> Set Packing</button>
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<style>
td {
    height: 30px;
}

.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 7px 4px 7px 4px;
    background: none;
    border: 1px solid #e4e6fc;
    border-radius: 4px;
    white-space: normal;
    min-width: 110px;
}
.vs__actions {
    padding: 0px 6px 0 3px;
}
.vs__clear {
    display:none;
}
.vs__dropdown-menu {
    background-color: white;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    position: absolute;
    z-index: 3000;
    max-height: 120px !important;
}
</style>

<script>
import Vue from 'vue'
import VCalendar from 'v-calendar';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

export default {
    data() {
        return {
            id_transaksi : '',
            transaksiDetail : [],
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            jenis_transaksi : '',
            tipe_transaksi : '',
            produkList : [],
            packageList: [],
            bodyRender : true,
            alamat : '',
            email : '',
            nomor_invoice : '',
            nomor_pengiriman : '',
            nomor_transaksi :'',
            // packingList : [],
            pelanggan : '',
            que : 0,
            pelangganList : [],
            pelangganDis : false,
            tanggal_pengiriman : '',
            id_kontak : '',
            pesan : '',
            memo : '',
            dataPackingList : []
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            this.nomor_pengiriman = ''
            this.nomor_invoice = '',
            this.tanggal_pengiriman = ''
            this.packageList = []
            //get supplier list
            this.$http.post("Kontak/getKontakList/customer").then(result => {
                if(result.data.code == '00'){
                    console.log('kontak pelanggan empty')
                }else {
                    this.pelangganList = result.data.detail
                    this.que = 1
                    if(this.que == 1){
                        this.getTransaksiDetail()
                    }
                }
            })

            //get Packing List
            this.$http.post("Transaksi/getPackingListProduk").then(result => {
                if(result.data.code == '00'){
                    console.log('packing list empty')
                }else {
                    this.dataPackingList = result.data.detail
                }
                this.$root.is_loading = false;
            })
            
        },
        getTransaksiDetail : function() {
            if(this.$route.params.id_transaksi != null){
                this.$root.is_loading = true
                this.id_transaksi = this.$route.params.id_transaksi
                this.$http.post("Transaksi/getTransaksiDetail/"+this.id_transaksi).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.transaksiDetail = result.data.detail
                        this.nomor_transaksi = this.transaksiDetail.detail.nomor_transaksi
                        this.pelanggan = this.transaksiDetail.detail.id_kontak
                        this.jenis_transaksi = result.data.detail.detail.jenis_transaksi
                        this.tipe_transaksi = result.data.detail.detail.tipe_transaksi+" #"+result.data.detail.detail.nomor_transaksi
                        this.id_kontak = this.transaksiDetail.detail.id_kontak
                        let that = this
                        this.$http.post("Transaksi/getProdukListByKontak/"+that.transaksiDetail.detail.id_kontak+"/"+that.transaksiDetail.detail.jenis_transaksi+"/"+that.transaksiDetail.detail.id_transaksi).then(result => {
                            if(result.data.code == '00') {
                                that.$parent.toastr = {
                                    title : 'Error',
                                    message: 'Something went wrong, please call developer !',
                                    type : 'error'
                                }
                            }
                            else {
                                if(result.data.detail.length == 0){
                                    that.$parent.toastr = {
                                        title : 'Warning',
                                        message: 'Tidak ada Produk PO',
                                        type : 'error'
                                    }
                                }
                                that.produkList = result.data.detail
                                that.produkList.forEach(function(item,index){
                                    that.produkList.qty_pack = 0
                                    if(item.pack_check == 1){
                                        that.produkList[index].pack_check = true
                                    }else{
                                        that.produkList[index].pack_check = false
                                    }
                                })
                            }
                        }, error => {
                            console.log('gk ok')
                            context.errors = errors;
                        });
                                                
                        this.pelangganList.forEach(function(item,index){
                            if(item.id_kontak == that.pelanggan){
                                that.pelanggan = index
                                that.alamat = that.transaksiDetail.detail.alamat_transaksi
                                that.email = that.transaksiDetail.detail.email_transaksi
                                that.pelangganDus = true
                                $("#pelanggan").val(that.pelanggan).trigger('change');
                                return that.pelanggan
                            }
                        })
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });

            }
        },
        submitPacking: function() {
        
            if(this.nomor_pengiriman == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan nomor pengiriman / surat jalan !',
                    type : 'warning'
                }
                return false
            }

            
            if(this.tanggal_pengiriman == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan tanggal pengiriman !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan data sudah benar !')){
                return false
            }

            var packingList = []
            let that = this
            this.produkList.forEach(function(item,index){
                if(item.pack_check == true){
                    that.produkList[index].total_kirim = parseFloat(item.qty_dikirim) + parseFloat(item.qty_pack)
                    if(that.produkList[index].total_kirim >= item.qty){
                        that.produkList[index].status_packing = 1
                    }
                    else {
                        that.produkList[index].status_packing = 0
                    }
                    packingList.push(item)
                }
            })

            if(packingList.length == 0){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tidak ada produk di pack !',
                    type : 'warning'
                }
                return false
            }
            
            var formsub = new FormData()

            var objThis = this
            $.map(packingList, function(value,index){
                    formsub.append('dataProduk['+index+'][id_produk]', value.id_produk);
                    formsub.append('dataProduk['+index+'][nama_satuan]', value.nama_satuan);
                    formsub.append('dataProduk['+index+'][nama_produk]', value.nama_produk);
                    formsub.append('dataProduk['+index+'][id_transaksi_produk]', value.id_transaksi_produk);
                    formsub.append('dataProduk['+index+'][qty_send]',value.qty_pack);
                    formsub.append('dataProduk['+index+'][total_kirim]',value.total_kirim);
                    formsub.append('dataProduk['+index+'][status_packing]', value.status_packing);
                    formsub.append('dataProduk['+index+'][id_produk_package]', value.id_produk_package);
                    formsub.append('dataProduk['+index+'][nama_produk_package]', value.nama_produk_package);
                    formsub.append('dataProduk['+index+'][qty_package]', value.qty_package);
            });

            $.map(this.packageList, function(value,index){
                formsub.append('dataPackage['+index+'][id_produk_package]', value.id_produk_package );
                formsub.append('dataPackage['+index+'][nama_produk_package]', value.nama_produk_package );
                formsub.append('dataPackage['+index+'][qty_package]', value.qty_package );
            }); 
            
            formsub.append('jenis_progress','penjualan');
            formsub.append('tanggal_pengiriman',this.formatDate(this.tanggal_pengiriman))
            formsub.append('nomor_pengiriman', this.nomor_pengiriman)
            formsub.append('nomor_invoice',this.nomor_invoice)
            formsub.append('pesan', this.pesan)
            formsub.append('memo',this.memo)
            formsub.append('alamat',this.alamat)
            formsub.append('email',this.email)
            formsub.append('id_transaksi',this.transaksiDetail.detail.id_transaksi)
            formsub.append('nomor_transaksi',this.nomor_transaksi)

            this.$http.post("Transaksi/updatePacking/"+this.id_kontak, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Packing berhasil diupdate !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init();
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Packing gagal diupdate !',
                        type : 'error'
                    }                 
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        goBack() {
            this.$router.replace({ path : window.localStorage.getItem('last_route') })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        insertValue(index){
            var val = this.packageList[index].val.split("|")
            this.packageList[index].id_produk_package = val[0]
            this.packageList[index].nama_produk_package = val[3]
            this.packageList[index].nama_satuan = val[2]
            if(val[5] == 'n'){
                this.packageList[index].qty_total = val[4]+' (Dipesan '+val[6]+')'
                this.packageList[index].max_qty = val[4]
            }else{
                this.packageList[index].qty_total = val[4]+' (Dipesan '+val[6]+')'+' (Produksi? '+val[5]+')'
                this.packageList[index].max_qty = val[5]
            }
        },
        addItem: function() {
			this.packageList.push({
                    id_produk_package: '',
                    nama_produk_package: '',
                    kode_produk: '',
                    val: '',
                    qty_package: 0,
                    nama_satuan: '',
                    harga_satuan: 0,
                    jumlah_harga: 0,
                    max_qty : 0
			});
        },
        deleteDataProduk: function(index) {
            this.$parent.toastr = {
                title : 'Success',
                message: 'Produk '+this.packageList[index].kode_produk+' | '+this.packageList[index].nama_produk+' berhasil dihapus !',
                type : 'success'
            }
            this.$nextTick(function(){
                this.packageList.splice(index, 1);
                this.bodyRender = false
                this.$nextTick(function(){
                    this.bodyRender = true
                })
            })
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/penjualan/TransaksiCreatePacking.vue